const config = {
  sessionInformation: {
    year: 2025,
    dates: "8-13",
    theme: "Christ the King",
    scripture: "Philippians 2:9-11",
    hymnNumber: 26,
    hymnName: "All Hail the Power of Jesus Name",
  },
  features: {
    news: false,
    pbhSearch: false,
    moreMusic: false,
  },
  calendarDetails: [
    {
      date: "April 19",
      details: "Spring Work Day",
    },
    {
      date: "May 24",
      details: "Spring Work Day",
    },
    {
      date: "June 7",
      details: "Spring Work Day",
    },
  ],
  trustees: [
    { name: "Larry Dalton", title: "President" },
    { name: "Joey Lowrance", title: "Vice President" },
    { name: "Jeff Coker", title: "Secretary/Treasurer" },
    { name: "Russell Elsenbrock" },
    { name: "Gerald Hendrix" },
    { name: "David Moore" },
    { name: "Susan Schneider" },
    { name: "Kathy Taylor" },
    { name: "John Watson" },
  ],
};

export default config;
